export default () => ({
    unacknowledgedNotifications: [],
    notificationsCount: 0
})
